import * as Sentry from '@sentry/react';
import { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import 'assets/css/index.css';
import {
  createRoutesFromChildren, matchRoutes, useLocation, useNavigationType,
} from 'react-router-dom';

import envConfig from 'configuration/env';

import packageJson from '../package.json';
import App from './App.jsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

if (import.meta.env.VITE_NODE_ENV !== 'dev') {
  Sentry.init({
    ...envConfig.sentryConfiguration,
    release: `${packageJson.name}@${packageJson.version}`,
    environment: import.meta.env.VITE_NODE_ENV,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  ReactGA.initialize(envConfig?.firebaseConfig?.measurementId);
}

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
